export function formatITCTime(
    timestampMs: number,
    firstTimeStamp: number,
    lastTimeStamp: number,
): string {
    const firstDate = new Date(firstTimeStamp);
    const lastDate = new Date(lastTimeStamp);

    // Convert timestamps to IST
    const timestampIST = new Date(timestampMs).toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
    });

    const date = new Date(timestampIST);

    // Check if the difference is greater than 24 hours
    const durationInHours =
        (lastDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60);

    if (durationInHours > 24) {
        // Format as "4 Nov" or "10 Mar"
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "short" });
        return `${day} ${month}`;
    } else {
        // Format as "HH:MM AM/PM" in IST
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");

        // Convert to 12-hour format with AM/PM
        const amPm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        return `${formattedHours}:${minutes} ${amPm}`;
    }
}

export const normalizeToPercentage = (data: number[]) => {
    return data?.map((value) => (value / 10) * 100);
};
